<template>
  <v-row>
    <v-col cols="12" :md="modalView ? 12 : 6" :offset-md="modalView ? 0 : 3">
      <ClientFormAutocomplete
          v-model="searchString"
          @selected="populateForm"
          label="Išči v registru (ime ali davčna številka)"
      ></ClientFormAutocomplete>

      <form @submit.prevent="save">
        <v-checkbox
          color="#0F998E"
          v-model="isEndUser"
          label="Končni potrošnik"
        ></v-checkbox>
        <v-text-field
          v-model="form.name"
          label="Ime *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.address"
          label="Ulica in hišna številka"
        ></v-text-field>
        <v-text-field
          v-model="form.post_code"
          label="Poštna številka"
        ></v-text-field>
        <v-text-field
          v-model="form.city"
          label="Kraj"
        ></v-text-field>
        <v-select
          :items="countryList"
          item-text="name"
          item-value="id"
          v-model="form.country_id"
          label="Država"
        ></v-select>
        <v-text-field
          v-model="form.tax_number"
          label="Davčna številka"
        ></v-text-field>
        <v-checkbox
          color="#0F998E"
          v-model="form.tax_bound"
          label="Davčni zavezanec"
        ></v-checkbox>
        <v-text-field
          v-model="form.register_number"
          label="Matična številka"
        ></v-text-field>
        <v-text-field
          v-model="form.account_number"
          label="Številka računa"
        ></v-text-field>
        <v-text-field
          v-model="form.required_payment_days"
          label="Rok plačila (št. dni)"
        ></v-text-field>
        <v-text-field
          v-model="form.discount"
          label="Popust %"
        ></v-text-field>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import ClientFormAutocomplete from '@/components/ClientFormAutocomplete'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    ClientFormAutocomplete
  },
  props: {
    countryList: {
      required: true,
      type: Array
    },
    client: {
      default: () => {},
      type: Object
    },
    modalView: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      searchString: '',
      isEndUser: false,
      form: {
        name: null,
        address: null,
        post_code: null,
        city: null,
        country_id: null,
        tax_number: null,
        tax_bound: false,
        account_number: null,
        client_type: 2,
        register_number: null,
        required_payment_days: 8,
        discount: 0
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    clearForm () {
      this.form = {
        name: null,
        address: null,
        post_code: null,
        city: null,
        country_id: null,
        tax_number: null,
        tax_bound: false,
        account_number: null,
        client_type: 2,
        register_number: null,
        required_payment_days: 8,
        discount: 0
      }
    },
    populateForm (companyData) {
      this.form.name = companyData.name || ''
      this.form.address = companyData.address || ''
      this.form.post_code = companyData.post_code || ''
      this.form.city = companyData.city || ''
      this.form.tax_bound = companyData.tax_bound || false
      this.form.tax_number = companyData.tax_number || ''
      this.form.register_number = companyData.register_number || ''
      this.form.account_number = companyData.account_number || ''
      this.form.discount = companyData.discount || 0

      const siCountryId = this.countryList.find(c => c.name.toLowerCase() === 'slovenija').id
      this.form.country_id = siCountryId
    }
  },
  created () {
    this.form = { ...this.form, ...this.client }
  },
  watch: {
    isEndUser (isEndUser) {
      this.form.client_type = isEndUser ? 1 : 2
    }
  }
}
</script>
